// Menu
let menu = document.querySelector('.main-header');
let templateUrl = object_name.templatedir;


function checkMenuIsClosed() {
    //IF MEGAMENU OPEN : CLOSE IT ON PAGE CHANGE

    if (document.querySelector('.megamenuActive')) {

        document.querySelector('.megamenuActive').classList.remove("megamenuActive");
    }
    document.querySelector('.main-header').classList.remove('is-open');

    if (document.querySelector('#menu-header-menu-fr')) {
        document.querySelector('#menu-header-menu-fr').classList.remove('is-active');
    }

    if (document.querySelector('#menu-header-menu')) {
        document.querySelector('#menu-header-menu').classList.remove('is-active');
    }
    if (document.querySelector('.btn-collapse')) {
        document.querySelector('.btn-collapse').classList.remove('is-active');
    }
}

function errorFormUpdateSmooth() {
    if (document.querySelector('.wpcf7-form')) {
        var messageFormAdded = document.querySelector('.wpcf7-form .wpcf7-response-output');
        messageFormAdded.addEventListener('DOMSubtreeModified', function () {
            setTimeout(function () {
                scroll.update();
            }, 500);
        });
    }
}

//IF CHECK AVAILABILITY WITH GIVEN DATE SCROLL DOWN DIRECLtY
function scrollToGivenDates() {
    setTimeout(function () {
        if (window.location.href.indexOf("?bk_check_in=") > -1) {
            //alert("your url contains");
            const target = document.querySelector('#booking_form_div2');
            scroll.scrollTo(target);
        }
    }, 1700);
}

// CALLED IN THE ONCE BARBA FUNCTION AND AFTER PAGE IS AJAXED LOADED
function initParts() {


    scrollToGivenDates();
    errorFormUpdateSmooth();
    checkMenuIsClosed();

    /*------Home page------*/
    // Video Background, playing, looping,  no sound
    const vimeoPlayer = document.querySelectorAll(".vimeo-player");
    // let players = [];
    if (vimeoPlayer) {
        vimeoPlayer.forEach((video) => {
            const player = new Plyr('#' + video.getAttribute("id"), {
                muted: true,
                autoplay: true,
                // playinline évite de lancer la video en full screen IOS natif
                playsinline: true,
                controls: [],
                // autopause - allow only one vimeo player. Works on vimeo only
                autopause: false,
                hideControls: true,
                loop: {
                    active: true
                },
                displayDuration: false,
                tooltips: {
                    focused: false,
                    seek: false
                }
            });
        });
    }

    // Slider with timer and buttons
    const sliderImg = document.querySelectorAll('.slider-img');
    if (sliderImg) {
        sliderImg.forEach((el) => {
            const dataAutoPlay = el.getAttribute("data-flickity-autoplay");

            const flkty = new Flickity(el, {
                // options
                autoPlay: dataAutoPlay ? +dataAutoPlay : false,
                draggable: false,
                cellAlign: 'left',
                prevNextButtons: false,
                imagesLoaded: true,
                // selectedAttraction: 0.02,
                pauseAutoPlayOnHover: false,
                contain: true,
                wrapAround: true,
                draggable: false
                //friction: 0.15
                //                on: {
                //                    staticClick: function (index) {
                //                        console.log('staticClick')
                //                    },
                //                    dragEnd: () => console.log('dragEnd'),
                //                    select: () => flkty.slider.unpause(),
                //                    pointerDown: () => console.log('pointerDown'),
                //                }

                //                 on: {
                //                    dragStart: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none"),
                //                    dragEnd: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
                //                }
            });
        })
    }

    // Slider Img free scroll
    const sliderFree = document.querySelectorAll('.slider-free');
    if (sliderFree) {
        sliderFree.forEach((el) => {
            const dataAutoPlay = el.getAttribute("data-flickity-autoplay");
            const flkty = new Flickity(el, {
                // options
                autoPlay: dataAutoPlay ? +dataAutoPlay : false,
                cellAlign: 'left',
                pageDots: false,
                imagesLoaded: true,
                contain: true,
                percentPosition: false,
                pauseAutoPlayOnHover: false,
                on: {
                    dragStart: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none"),
                    dragEnd: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
                }
            });
        });
        // console.log('launch slider');
    }

    // Slider end of web page for invitations
    const sliderInvitations = document.querySelectorAll('.slider-invitations');
    if (sliderInvitations) {
        sliderInvitations.forEach((el) => {
            const flkty = new Flickity(el, {
                // options
                autoPlay: false,
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                percentPosition: false,
                on: {
                    dragStart: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none"),
                    dragEnd: () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all")
                }
            });
        })
    }

    // Tabs panel
    const tabs = document.querySelectorAll('.tabs');
    // if (tabs) {
    //     tabs.forEach((el) => {
    //         console.log('PASSE TABS');
    //         let tabNav = el.querySelectorAll(".tabs-nav .tab");
    //         let tabPanel = el.querySelectorAll(".tabs-panel .panel");
    //         tabNav.forEach(function (nav, index) {
    //             nav.addEventListener("click", function (e) {
    //                 if (nav.classList.contains("is-active")) {
    //                     e.preventDefault();
    //                     nav.closest(".tabs-nav").classList.toggle('is-show');
    //                 } else
    //                     nav.closest(".tabs-nav").classList.remove('is-show');
    //
    //                 tabNav.forEach((el) => {
    //                     el.classList.remove("is-active");
    //                 });
    //
    //                 tabPanel.forEach((el) => {
    //                     el.classList.remove("is-active");
    //                 });
    //
    //                 nav.classList.add('is-active');
    //                 tabPanel[index].classList.add('is-active');
    //             });
    //         });
    //     });
    // }

    if (tabs) {
        tabs.forEach((el) => {
            let current = -1;
            let container = el.querySelector('.tabs-panel')
            let list = el.querySelectorAll('.tabs-nav .tab')
            let items = el.querySelectorAll('.panel')

            list.forEach((l) => {
                l.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (l.classList.contains("is-active")) {
                        l.closest(".tabs-nav").classList.toggle('is-show');
                    } else
                        l.closest(".tabs-nav").classList.remove('is-show');

                    let countTabItem = list.length;
                    let percentTabItem = 100 / countTabItem;

                    if (l.classList.contains('is-active')) return;
                    l.classList.add('is-active')

                    let index = [...l.parentElement.children].indexOf(l);

                    let dir = index > current ? 1 : -1;

                    if (current >= 0) {
                        list[current].classList.remove('is-active')
                        gsap.to(items[current], {
                            duration: 0.6,
                            x: (dir * -percentTabItem) + '%',
                            autoAlpha: 0,
                            ease: "cubic.inOut"
                        })
                    }

                    gsap.fromTo(items[index], {
                        x: (dir * percentTabItem) + '%',
                        autoAlpha: 0
                    }, {
                        duration: 0.6,
                        x: '0%',
                        autoAlpha: 1,
                        ease: "cubic.out",
                        delay: 0.3
                    });

                    current = index;

                    window.dispatchEvent(new Event('resize'))
                })
            })

            window.addEventListener('resize', () => {
                gsap.to(container, {
                    duration: .2,
                    height: items[current].offsetHeight
                });
            })

            list[0].dispatchEvent(new Event('click'));
        })
    }

    // Lightbox
    // if (document.querySelector('.fancybox')) {
    //     $('.fancybox').fancybox({
    //         closeExisting: false,
    //         loop: false,
    //         gutter: 50,
    //         keyboard: true,
    //         preventCaptionOverlap: true,
    //         arrows: true,
    //         infobar: true,
    //         smallBtn: "auto",
    //         toolbar: true,
    //         buttons: [
    //             "close"
    //         ],
    //         idleTime: 3,
    //         protect: false,
    //         modal: false,
    //         image: {
    //             preload: true
    //         },
    //         defaultType: "image",
    //         animationEffect: "zoom",
    //         animationDuration: 366,
    //         zoomOpacity: "auto",
    //         transitionEffect: "fade",
    //         transitionDuration: 366,
    //         slideClass: "",
    //         baseClass: "",
    //         baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
    //             `<div class="fancybox-bg"></div>` +
    //             `<div class="fancybox-inner">` +
    //             `<a class="fancybox-logo" href="/"><img src=" ${templateUrl}/assets/img/logo-gray.svg"></a>` +
    //             `<div class="fancybox-toolbar">{{buttons}}</div>` +
    //             `<div class="fancybox-navigation">{{arrows}}</div>` +
    //             `<div class="fancybox-stage"></div>` +
    //             `<div class="fancybox-wrap-caption">` +
    //             `<div class="fancybox-caption">` +
    //             `<div class="fancybox-caption__body"></div></div>` +
    //             `<div class="fancybox-infobar">` +
    //             `<span data-fancybox-prev><img src=" ${templateUrl}/assets/img/arrow-left.svg"></span>` +
    //             `<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>` +
    //             `<span data-fancybox-next><img src=" ${templateUrl}/assets/img/arrow-right.svg"></span>` +
    //             `</div>` +
    //             `</div>` +
    //             `</div>` +
    //             `</div>`,
    //         btnTpl: {
    //             close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
    //                 '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
    //                 "</button>",
    //             arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
    //                 "</button>",
    //             arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
    //                 "</button>",
    //             smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
    //                 '<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
    //                 "</button>"
    //         },
    //         parentEl: "body",
    //         hideScrollbar: true,
    //         autoFocus: true,
    //         backFocus: false,
    //         trapFocus: true,
    //         fullScreen: {
    //             autoStart: false
    //         },
    //         touch: {
    //             vertical: true, // Allow to drag content vertically
    //             momentum: true // Continue movement after releasing mouse/touch when panning
    //         },
    //         hash: null,
    //         media: {},
    //         slideShow: {
    //             autoStart: false,
    //             speed: 3000
    //         },
    //         thumbs: {
    //             autoStart: false, // Display thumbnails on opening
    //             hideOnClose: true, // Hide thumbnail grid when closing animation starts
    //             parentEl: ".fancybox-container", // Container is injected into this element
    //             axis: "y" // Vertical (y) or horizontal (x) scrolling
    //         },
    //         wheel: "auto",
    //         afterShow: function() {
    //             $(".fancybox-button--arrow_left").css('background-image', 'url(' + $('.fancybox[data-fancybox="' + this.opts.fancybox + '"]').closest('figure').eq(this.index - 1).find('a').attr("href") + ')');
    //             $(".fancybox-button--arrow_right").css('background-image', 'url(' + $('.fancybox[data-fancybox="' + this.opts.fancybox + '"]').closest('figure').eq(this.index + 1).find('a').attr("href") + ')');
    //         },
    //         clickSlide: false,
    //         clickOutside: false
    //     });
    // }

    // Select Choices.js
    if (document.querySelector('.js-choice')) {
        const choices = document.querySelectorAll('.js-choice');
        choices.forEach((select) => {
            const choice = new Choices(select, {
                searchEnabled: false,
                placeholder: false,
                placeholderValue: null,
                searchPlaceholderValue: null,
            });
        })
    }
    // playAnimLogo();

    // playAnimTransition();

    // ADD DATA SCROLL
    if (document.querySelector('.addDataScroll')) {

        document.querySelectorAll('.addDataScroll').forEach(function (thisElement, index) {
            var attributeElementToAddScroll = thisElement.getAttribute('data-give-scroll-to');

            //            console.log('attributeElementToAddScroll' + attributeElementToAddScroll);
            var propertyToAddScrollDirection = thisElement.getAttribute('data-give-scroll-direction');
            //            console.log('propertyToAddScrollDirection' + propertyToAddScrollDirection);

            var propertyToAddScrollSpeed = thisElement.getAttribute('data-give-scroll-speed');
            //            console.log('propertyToAddScrollSpeed' + propertyToAddScrollSpeed);

            var elementsToAddScroll = thisElement.querySelector(attributeElementToAddScroll);

            //            console.log(elementsToAddScroll);
            elementsToAddScroll.setAttribute('data-scroll', '');
            elementsToAddScroll.setAttribute('data-scroll-direction', propertyToAddScrollDirection);
            elementsToAddScroll.setAttribute('data-scroll-speed', propertyToAddScrollSpeed);
        });
    }

    // INVITATIONS ADD SCROLL ATTRIBUTES
    if (document.querySelector('.article-content')) {
        var containerArticle = document.querySelector('.article-content');
        document.querySelectorAll('p').forEach(function (thisElement, index) {
            thisElement.setAttribute('data-scroll', '');
            thisElement.setAttribute('data-scroll-repeat', '');
        });
        document.querySelectorAll('h2').forEach(function (thisElement, index) {
            thisElement.setAttribute('data-scroll', '');
            thisElement.setAttribute('data-scroll-repeat', '');
        });
        document.querySelectorAll('.wp-block-image').forEach(function (thisElement, index) {
            thisElement.querySelector('img').setAttribute('data-scroll', '');
            //            thisElement.querySelector('img').setAttribute('data-scroll-repeat', '');
            thisElement.querySelector('img').setAttribute('data-scroll-speed', '-1');
        });

    }
    // PAGE PROJECT ADD SCROLL ATTRIBUTES
    if (document.querySelector('.page-template-project')) {

        document.querySelectorAll('.wp-block-image').forEach(function (thisElement, index) {
            thisElement.querySelector('img').setAttribute('data-scroll', '');
            //            thisElement.querySelector('img').setAttribute('data-scroll-repeat', '');
            thisElement.querySelector('img').setAttribute('data-scroll-speed', '-1');
        });
    }

    // PERMET d'update la hauteur du scroll lors de l'ajout de contenu lié aux alerte du formulaire
    // if (document.querySelector('.bookFormSection .submiting_content')) {
    //     let alertMessage = document.querySelector('.bookFormSection .submiting_content');
    //     alertMessage.addEventListener('DOMSubtreeModified', function () {
    //         scroll.update();
    //     });
    // }
}

function mapHome() {
    //bodymovin map HOME

    if (document.querySelector('#animMapHome')) {
        let animMapHomeParameters1 = {
            wrapper: document.getElementById('animMapHome'),
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: templateUrl + '/assets/json/data-intro-only.json'
        };

        let animMapHome = bodymovin.loadAnimation(animMapHomeParameters1);

        launchAnimMapHome = function playAnimMapHome() {
            // console.log("------ playanim MAP ------");
            animMapHome.stop();
            animMapHome.setSpeed(1);
            animMapHome.play();
        }
    }
}

// LAUNCH ONLY ONCE
(function () {

    // NE PAS AFFICHER SCROLL DOWN INDICATOR SI PAS SUR LA HOMEPAGE
    setTimeout(() => {
        if (document.querySelector('.home')) {
            document.getElementById('scrollpage')?.classList.remove('is-hidden');
        }
    }, 700);

    // PERMET DE GERER LES CONTACT FORM 7 EN AJAX
    const btnCollapse = document.querySelector('.btn-collapse');

    btnCollapse.addEventListener('click', (event) => {
        btnCollapse.classList.toggle('is-active');
        document.querySelector('.main-header').classList.toggle('is-open');


        if (document.querySelector('#menu-header-menu-fr')) {
            document.querySelector('#menu-header-menu-fr').classList.toggle('is-active');
        }

        if (document.querySelector('#menu-header-menu-en')) {
            document.querySelector('#menu-header-menu-en').classList.toggle('is-active');
        }

        if (document.querySelector('#menu-header-menu')) {
            document.querySelector('#menu-header-menu').classList.toggle('is-active');
        }

        if (document.querySelector('.main-header.is-open')) {
            //            console.log("--------------- ANIMATIONS MENU MOBILE ---------------");
            // gsap.from(".main-header #menu-header-menu .menu-item", {
            //     opacity: 0,
            //     duration: 0.5,
            //     delay: 0.2,
            //     stagger: function(index, target, list) {
            //         return index * 0.1;
            //     }
            // });

            gsap.from(".main-header .languages", {
                opacity: 0,
                duration: 0.5,
                delay: 0.6,
            });

        }
    });


    //Megamenu OPEN/CLOSE
    const btnMegamenu = document.querySelector('.the-region-link a');
    // btnMegamenu.querySelector('a').setAttribute('href', '#');

    if (btnMegamenu) {
        btnMegamenu.addEventListener('click', (event) => {
            // console.log('OPEN MEGA MENU');
            menu.classList.toggle('megamenuActive');
            // event.preventDefault();
            if (document.querySelector('.megamenuActive')) {
                //            console.log("--------------- ANIMATIONS MEGAMENU ---------------");
                document.querySelector('#menuBackgroundVimeo').classList.add('display-block');
                gsap.from(".megaMenuContainer", {
                    y: "-30%",
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.2,
                });

                //COL1
                gsap.from("#megaMenuCol1 figure", {
                    //            x: "-20%",
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.2,
                });
                gsap.from("#megaMenuCol1 .megaMenuTitle", {
                    //            x: "-20%",
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.4,
                });
                gsap.from("#megaMenuCol1 a", {
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.6,
                });

                //COL2
                gsap.from("#megaMenuCol2 .columnTitle", {
                    //            x: "-20%",
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.4,
                });
                gsap.from("#megaMenuCol2 .itemLinks", {
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.5,
                    stagger: function (index, target, list) {
                        return index * 0.05;
                    }
                });
                gsap.from("#megaMenuCol2 .btn", {
                    opacity: 0,
                    duration: 0.5,
                    delay: 0.6,
                });
            } else {
                document.querySelector('#menuBackgroundVimeo').classList.remove('display-block');
            }
        });
    }

    if (!mobile) {
        document.querySelector('.main-header').addEventListener("mouseover", function () {
            document.querySelector('header.main-header').classList.remove('putHeaderOutside');
        })
    }
    document.querySelectorAll('.megaMenuContainer a').forEach(function (thisLink, index) {
        thisLink.addEventListener('click', function (event) {
            menu.classList.remove('megamenuActive');
        });
    });

    // //Megamenu CLOSE MOBILE
    // const btnMegamenuMobile = document.querySelector('.megamenuClose');
    // btnMegamenuMobile.addEventListener('click', (event) => {
    //     menu.classList.remove('megamenuActive');
    //     event.preventDefault();
    // })

})();




